import PropTypes from 'prop-types';
import React, { Fragment } from 'react';

import AdTypeMenuItem from './AdTypeMenuItem';
import AdTypeMenuHeading from './AdTypeMenuHeading';
import { Partner } from '../partners/partner';

const AdTypeVideoMenu = props => {
  const { partner, onSelectMenu, $state } = props;

  return (
    <Fragment>
      <AdTypeMenuHeading
        onClick={() => onSelectMenu('main')}
        title="Video"
      />

      <div className="ad-type-menu__rich-media">
        {partner.hasAdType('native_outstream') && (
          <AdTypeMenuItem
            heading="Native Outstream"
            subheading="Generate a video unit that silently autoplays (video file required)"
            iconSrc="https://legacy-design-assets.s3.amazonaws.com/images/ad-types/video.png"
            onClick={() => {
              $state.go('creativePreview.edit.example', {
                id: 'instantPlayCard'
              });
            }}
            testId="native-outstream"
          />
        )}
        {partner.hasAdType('instream_video') && (
          <AdTypeMenuItem
            heading="Instream with captions (new)"
            subheading="Generate a video unit that silently autoplays (video file required)"
            iconSrc="https://legacy-design-assets.s3.amazonaws.com/images/ad-types/video.png"
            onClick={() => {
              $state.go('creativePreview.edit.example', {
                id: 'instantPlayCardInstream',
              });
            }}
            testId="instream-video"
          />
        )}
      </div>
    </Fragment>
  );
};

AdTypeVideoMenu.propTypes = {
  $state: PropTypes.object.isRequired,
  partner: PropTypes.instanceOf(Partner).isRequired,
  onSelectMenu: PropTypes.func.isRequired
};

export default AdTypeVideoMenu;
